import environment from '../environment';
import { ActionStatus } from '../constants/action-status';
import { GetUserProfileState } from '../../features/user-profile/user-profile.interface';
import { REDIRECT_URL_HECLR_KEY } from '../constants/api-constants';
import emit from '../events';

/**
 * Return the loginUrl with the redirectUrl param to the same page the user is.
 */
export function getLoginURLWithRedirectUrlToCurrentPage(): string {
  const url = new URL(environment().loginUrl);
  url.searchParams.set(REDIRECT_URL_HECLR_KEY, window.location.href);
  return url.toString();
}

/**
 * Return the loginUrl with the redirectUrl param to the same page the user is.
 */
export function getLoginURLWithRedirectUrlToPage(redirectUrl: string): string {
  const url = new URL(environment().loginUrl);
  url.searchParams.set(REDIRECT_URL_HECLR_KEY, redirectUrl);
  return url.toString();
}

/**
 * Redirects the user to the login page when not logged in.
 *
 * @param userProfileResponse
 */
export function checkForRedirectToLogin(userProfileResponse: GetUserProfileState): void {
  if (window.Mhecomm_Editor) {
    return;
  }

  if (
    userProfileResponse.status === ActionStatus.failed ||
    (userProfileResponse.status === ActionStatus.succeeded && !userProfileResponse.data)
  ) {
    window.location.href = environment().loginUrl;
  }
}

let capturedAnalytics = false;
export function captureUserLoginFromAlertAnalytics(event: Event, element): void {
  event.preventDefault();
  if (capturedAnalytics) return;
  capturedAnalytics = true;

  emit({
    element: element,
    name: 'click',
    detail: {
      eventName: `mhecomm-user-alert-login-link-clicked`,
      label: 'User Logged In',
      url: window.location.href,
      comp: 'login',
    }
  });

  window.location.href = (event.currentTarget as HTMLAnchorElement).href;
}
